import { render, staticRenderFns } from "./XsMobileBind.vue?vue&type=template&id=36f740c8&"
import script from "./XsMobileBind.vue?vue&type=script&lang=js&"
export * from "./XsMobileBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports